<div class="app-data-grid" [class.hover-muted]="hoverVariant === 'muted'">
  <ng-content></ng-content>
</div>
